import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { getAllUnits as onGetAllUnits } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AddNewUnit = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    unitName: null,
  })

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-unit-code').focus();
      document.getElementById('inp-unit-code').select();
    }, 250);
    
    if(props.enteredText != ''){
      setUnitName(props.enteredText)
    }
  }, [props.enteredText])

  const [unitName, setUnitName] = useState('')
  const [unitDescription, setUnitDescription] = useState('')
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    if(props.isEdit){
      setUnitName(props.detailsForEdit.name)
      setUnitDescription(props.detailsForEdit.details)
    }
  }, [props.detailsForEdit])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(unitName && unitName != ""){
      modifiedV["unitName"] = true
    }
    else{
      modifiedV["unitName"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()
    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': unitName,
        'inputValue' : unitDescription
      }, 'Unit')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllUnits(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'name': unitName,
          'details' : unitDescription
        }, 'Unit')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllUnits(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-unit-code">
                              Unit Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-unit-code"
                              maxLength="20"
                              value={unitName}
                              onChange={event => {
                                onChangeValidation("unitName", event.target.value.trim())
                                setUnitName(event.target.value)
                              }}
                              invalid={
                                validation["unitName"] !== true &&
                                validation["unitName"] !== null
                              }
                            />
                            {(validation["unitName"] === false) &&
                              <div className="custom-error">
                                Please enter the Unit Name
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              Unit Description
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="100"
                              value={unitDescription}
                              onChange={event => {
                                onChangeValidation("unitDescription", event.target.value.trim())
                                setUnitDescription(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                EDIT
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewUnit.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewUnit
